export default __webpack_public_path__ + "static/media/TIENLEN_HISTORY_MOBILE-ENG.85efcd29.jpg";